(function () {
    const $slider = $('.product-gallery__thumbnails-holder');
  
    function updateArrowStatesViaAria($holder) {
      const $slides = $holder.find('.thumbnail.slick-slide');
      const $visibleSlides = $slides.filter('[aria-hidden="false"]');
      const $prevArrow = $holder.find('.p-arrow');
      const $nextArrow = $holder.find('.n-arrow');
  
      if (!$visibleSlides.length) return;
  
      const firstVisible = $visibleSlides.first().data('slick-index');
      const lastVisible = $visibleSlides.last().data('slick-index');
  
      const firstSlideIndex = $slides.first().data('slick-index');
      const lastSlideIndex = $slides.last().data('slick-index');
  
      // Disable prev if first visible is the first overall
      if (firstVisible === firstSlideIndex) {
        $prevArrow.css('pointer-events', 'none').addClass('slick-disabled');
      } else {
        $prevArrow.css('pointer-events', '').removeClass('slick-disabled');
      }
  
      // Disable next if last visible is the last overall
      if (lastVisible === lastSlideIndex) {
        $nextArrow.css('pointer-events', 'none').addClass('slick-disabled');
      } else {
        $nextArrow.css('pointer-events', '').removeClass('slick-disabled');
      }
    }
  
    function setupArrowStateListeners($holder) {
      $holder.on('afterChange', function () {
        updateArrowStatesViaAria($holder);
      });
  
      updateArrowStatesViaAria($holder); // initial call
    }
  
    $(document).on('shopify:section:load', function () {
      const $newSlider = $('.product-gallery__thumbnails-holder');
      if ($newSlider.length) {
        $newSlider.on('init', function () {
          setupArrowStateListeners($newSlider);
        });
  
        if ($newSlider.hasClass('slick-initialized')) {
          setupArrowStateListeners($newSlider);
        }
      }
    });
  
    $(document).ready(function () {
      if ($slider.length) {
        $slider.on('init', function () {
          setupArrowStateListeners($slider);
        });
  
        if ($slider.hasClass('slick-initialized')) {
          setupArrowStateListeners($slider);
        }
      }
    });
  })();